// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"5b0eb3021b4d2817544e","293":"dca8a93052c9cabe3b23","518":"955163764c288f12f6a1","779":"f4290b3c5127d6bfb74a"}[chunkId] + ".js";
};